<template>
  <div class="errors-list-modal">
    <p>{{ message }}</p>

    <ErrorsList :errors="errors" class="errors-list-modal__list" />

    <div class="text-left">
      <ElButton
        class="errors-list-modal__confirm"
        type="primary"
        @click="$modal.close(true)"
      >
        {{ $t('APP.RELEASES.PUBLISH_RULES.CONFIRM') }}
      </ElButton>
    </div>
  </div>
</template>

<script>
import ErrorsList from './ErrorsList';
export default {
  name: 'ErrorsListModal',
  components: { ErrorsList },
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
    message: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.errors-list-modal {
  &__list {
    font-size: 100%;
  }
}
</style>
